import type { InvestorFirmSalesCoverage_UnderwriterEmployeeFragment } from './graphql/__generated__';

export function mapEmployeeToOption({
  id,
  employeeKey,
  name,
  userAccount,
}: InvestorFirmSalesCoverage_UnderwriterEmployeeFragment) {
  return {
    label: name ?? userAccount?.name ?? id,
    value: id,
    employeeKey,
  };
}
